import type { FC } from 'react';

import {
  formatLocalDate,
  formatRelativeDate,
} from '@iconik-io/core/src/date/format';

import { selectDateTimeFormat } from '../../ducks/settings/select_date_time_format';
import { useAppSelector } from '../../store/react_redux_typed';
import TooltipTrigger from '../tooltip_trigger/tooltip_trigger';
import UserBubble from '../user_bubble/user_bubble';

import styles from './segment.module.css';

type Props = {
  photoUrl?: string;
  userName: string;
  dateCreated?: string;
  versionName?: string;
};

export const SegmentHeaderUser: FC<Props> = ({
  photoUrl,
  userName,
  dateCreated,
  versionName,
}) => {
  const dateTimeFormat = useAppSelector(selectDateTimeFormat);
  const date = dateCreated ? formatRelativeDate(dateCreated) : null;

  return (
    <>
      <UserBubble
        size="xs"
        className={styles.user}
        src={photoUrl}
        name={userName}
        showTooltip={false}
      />
      <div className={styles.user_info}>
        {userName ? (
          <span className={styles.user_name}>{userName}</span>
        ) : undefined}
        {dateCreated ? (
          <p className={styles.date}>
            {versionName ? (
              <span className={styles.version}>{versionName}</span>
            ) : null}
            <TooltipTrigger
              tooltipText={formatLocalDate(dateCreated, dateTimeFormat)}
              component="span"
            >
              {date}
            </TooltipTrigger>
          </p>
        ) : null}
      </div>
    </>
  );
};
